<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img src="/img/avatars/7.jpg" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account {{token.username}} ( {{token.account_group}} ) </strong>
    </CDropdownHeader>
    <CDropdownItem @click="handleLogout">
      <CIcon name="cil-lock-locked" />Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import jwt from "jsonwebtoken";

export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42,
      token :  jwt.decode(localStorage.getItem("token"))
    };
  },
  methods: {
    handleLogout() {
      localStorage.removeItem("token");
      this.$router.push({ path: `/pages/login` });
    }
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>